(function () {
  angular.module("akitabox.ui.components.workOrderCalendar", [
    "ui.calendar",
    "akitabox.core.lib.moment",
    "akitabox.core.services.workOrder",
    "akitabox.core.toast",
    "akitabox.ui.dialogs.workOrder.detail",
  ]);
})();
